import React, { useMemo, useState } from "react";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { Dropdown } from "react-bootstrap";

import ChevronBottomIcon from "../../assets/imgs/chevron-bottom-icon.svg";
import {
  buildCompositionDonutModel,
  findMeasurementByVisitDate,
} from "./detailed-progress-utils";

ChartJS.register(ArcElement, Tooltip, Legend);

const CompositionDonutPanel = ({
  measurements = [],
  visitOptions = [],
  selectedVisitDate,
  onVisitDateChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedOption = visitOptions.find((option) => option.value === selectedVisitDate);
  const selectedLabel = selectedOption?.label || "Selecionar data";

  const selectedMeasurement = useMemo(
    () => findMeasurementByVisitDate(measurements, selectedVisitDate),
    [measurements, selectedVisitDate]
  );

  const donutModel = useMemo(
    () => buildCompositionDonutModel(selectedMeasurement),
    [selectedMeasurement]
  );

  return (
    <section className="anthropometry-detailed-progress__card anthropometry-detailed-progress__card--donut">
      <div className="anthropometry-detailed-progress__card__header anthropometry-detailed-progress__card__header--donut">
        <div>
          <h2>Composição corporal</h2>
          <p>Massa magra e gordura total na visita selecionada</p>
        </div>

        {visitOptions.length > 0 && (
          <Dropdown show={isOpen} onToggle={setIsOpen} align="end">
            <button
              type="button"
              className={`anthropometry-detailed-progress__visit-range__trigger${
                isOpen ? " anthropometry-detailed-progress__visit-range__trigger--active" : ""
              }`}
              aria-label="Selecionar data da visita"
              onClick={() => setIsOpen((current) => !current)}
            >
              <span>{selectedLabel}</span>
              <img src={ChevronBottomIcon} alt="" />
            </button>
            <Dropdown.Menu className="anthropometry-detailed-progress__visit-range__menu">
              {visitOptions.map((option) => (
                <Dropdown.Item
                  key={option.value}
                  as="button"
                  className={`anthropometry-detailed-progress__visit-range__option${
                    option.value === selectedVisitDate
                      ? " anthropometry-detailed-progress__visit-range__option--selected"
                      : ""
                  }`}
                  onClick={() => {
                    onVisitDateChange(option.value);
                    setIsOpen(false);
                  }}
                >
                  {option.label}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>

      {donutModel.hasValues ? (
        <>
          <div className="anthropometry-detailed-progress__donut-chart">
            <Doughnut data={donutModel.chartData} options={donutModel.chartOptions} />
            <div className="anthropometry-detailed-progress__donut-chart__center">
              <strong>
                {donutModel.total.toLocaleString("pt-BR", { maximumFractionDigits: 1 })}
              </strong>
              <span>kg total</span>
            </div>
          </div>

          <div className="anthropometry-detailed-progress__donut-stats">
            <article className="anthropometry-detailed-progress__donut-stat">
              <span className="anthropometry-detailed-progress__donut-stat__dot anthropometry-detailed-progress__donut-stat__dot--lean" />
              <div>
                <p>Massa magra</p>
                <strong>
                  {donutModel.lean.toLocaleString("pt-BR", { maximumFractionDigits: 1 })} kg
                </strong>
              </div>
            </article>
            <article className="anthropometry-detailed-progress__donut-stat">
              <span className="anthropometry-detailed-progress__donut-stat__dot anthropometry-detailed-progress__donut-stat__dot--fat" />
              <div>
                <p>Gordura</p>
                <strong>
                  {donutModel.fat.toLocaleString("pt-BR", { maximumFractionDigits: 1 })} kg
                </strong>
              </div>
            </article>
          </div>
        </>
      ) : (
        <div className="anthropometry-detailed-progress__panel-empty">
          <p>
            Ainda não há massa magra e gordura registradas para exibir o gráfico. Registre dobras
            cutâneas com protocolo selecionado.
          </p>
        </div>
      )}
    </section>
  );
};

export default CompositionDonutPanel;
